// Breakpoints:
// 1em = 16px
// L: 1200px / 1em = 75em
// M: 1000px
// S: 800px
// XS: 600px
// XXS: 500px
// XXXS: 400px
export const respondTo = {
    L: 'only screen and (max-width: 75em)',
    M: 'only screen and (max-width: 62.5em)',
    S: 'only screen and (max-width: 50em)',
    XS: 'only screen and (max-width: 37.5em)',
    XXS: 'only screen and (max-width: 31.25em)',
    XXXS: 'only screen and (max-width: 25em)',
};
